// extracted by mini-css-extract-plugin
module.exports = {"cascader":"RiskBandsAdvancedSettings_cascader__6j63j"};